import React from "react";

import { Box, Button } from "@braintrust/braintrust-ui-components";

import style from "./style.module.scss";

export type FilterFooterProps = {
  onReset: () => void;
  onApply: () => void;
  disableApply?: boolean;
  hideClear?: boolean;
  singleValue?: boolean;
};

export const FilterFooter: React.FC<FilterFooterProps> = ({
  onReset,
  onApply,
  disableApply,
  hideClear,
  singleValue,
}) => {
  return (
    <Box className={style.filterFooter}>
      {!hideClear && (
        <Button
          variant="transparent-grey"
          shape="squared"
          size="x-small"
          sx={{
            ml: -1,
          }}
          onClick={() => {
            onReset();
          }}
        >
          {singleValue ? "Clear" : "Clear all"}
        </Button>
      )}
      <Button
        onClick={() => {
          onApply();
        }}
        variant="dark-violet"
        sx={{
          marginLeft: "auto",
        }}
        disabled={disableApply}
        shape="squared"
      >
        Apply
      </Button>
    </Box>
  );
};
